import { RestResponse } from 'src/_panel/comun/js--base--unimat--local'
import AccesoServicios from 'src/_panel/module/uni-base/services/AccesoServicios'
import { IIModel } from 'src/model/candidato-api'

export interface RestClientResponse<T extends IIModel> extends RestResponse<T> {}

export interface IHalResource<T> {}

export interface IHalRestFindResponse<T extends IIModel> {
  _embedded: {
    [list: string]: IHalResource<T>[]
  }
}

export class RestClient<T extends IIModel> {
  constructor(
    private AccesoServicios: AccesoServicios,
    private baseurl: string,
    private resource: string,
    private idprop: (item: T) => number
  ) {}

  private _getListado(listado: IHalRestFindResponse<T>) {
    return listado._embedded[this.resource] as T[]
  }

  findAll(): RestClientResponse<T[]> {
    return this.AccesoServicios._call('GET', this.baseurl, null, null, 'Fallo 1').then(
      (listado: IHalRestFindResponse<T>) => {
        return this._getListado(listado)
      }
    )
  }

  save(item: T): RestClientResponse<T> {
    let _id = this.idprop(item)

    return this.AccesoServicios._call('PUT', this.baseurl + '/' + _id, item, null, 'Fallo save')
  }

  add(item: T): RestClientResponse<T> {
    return this.AccesoServicios._call('POST', this.baseurl, item, null, 'Fallo add')
  }

  delete(item: T): RestClientResponse<T> {
    return this.AccesoServicios._call('DELETE', this.baseurl, item, null, 'Fallo delete')
  }
}
